import { concatAll } from '../operators/concatAll';
import { popScheduler } from '../util/args';
import { from } from './from';
export function concat(...args) {
    return concatAll()(from(args, popScheduler(args)));
}
//# sourceMappingURL=concat.js.map